// Iter 40 — Rule Validation State: shared labels/colours for business rules
// (proposed → validated | rejected) and AI deliverables (ai_inferred → validated | rejected).
export const RULE_STATES = ["proposed", "validated", "rejected"];
export const DELIVERABLE_STATES = ["ai_inferred", "validated", "rejected"];

// Carbon palette: inference = purple (same hue the app uses for "not proven" evidence),
// validated = green, rejected = neutral grey.
export const STATE_META = {
  proposed:    { label: "Inference",    hint: "Extracted by the parser — not yet reviewed by a consultant.",
                 bg: "#f6f2ff", fg: "#6929c4", border: "#d4bbff" },
  ai_inferred: { label: "AI inference", hint: "Written by the AI — not yet reviewed by a consultant.",
                 bg: "#f6f2ff", fg: "#6929c4", border: "#d4bbff" },
  validated:   { label: "Validated",    hint: "Reviewed and confirmed by a consultant.",
                 bg: "#defbe6", fg: "#0e6027", border: "#a7f0ba" },
  rejected:    { label: "Rejected",     hint: "Reviewed and dismissed by a consultant.",
                 bg: "#f4f4f4", fg: "#525252", border: "#c6c6c6" },
};

export const stateMeta = (state) => STATE_META[state] || STATE_META.proposed;

/** The "reopen" target differs per entity: rules go back to proposed, deliverables to ai_inferred. */
export const reopenStateFor = (kind) => (kind === "deliverable" ? "ai_inferred" : "proposed");

export const formatDecided = (row) => {
  if (!row?.decided_by) return "";
  const when = row.decided_at ? new Date(row.decided_at).toLocaleString() : "";
  return `${row.decided_by}${when ? ` · ${when}` : ""}`;
};
